export default __webpack_public_path__ + "static/media/hot-17.f4d36cfd.png";